export default {
	checkLists: ['onboarding', 'moving'],
};
